import { render, staticRenderFns } from "./DataLeakIssueBody.vue?vue&type=template&id=066beb7c&scoped=true"
import script from "./DataLeakIssueBody.vue?vue&type=script&lang=js"
export * from "./DataLeakIssueBody.vue?vue&type=script&lang=js"
import style0 from "./DataLeakIssueBody.vue?vue&type=style&index=0&id=066beb7c&prod&lang=scss&scoped=true"
import style1 from "./DataLeakIssueBody.vue?vue&type=style&index=1&id=066beb7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066beb7c",
  null
  
)

export default component.exports